import React, { Component } from "react";
import Avatar from "react-avatar";
import { Link } from "react-router";
import { changeLocation } from "api/Location";

import dropdownArrowIcon from "containers/assets/icon-dropdown-arrow.svg";
import Auth from "routes/Auth";
import MyProfileLink from "./my-profile-link";
import TeamProfileLink from "./team-profile-link";
import EventEmitter from "services/event-emitter";
import { OPEN_CONTACT_SUPPORT_EVENT } from "components/contact-support";

// Map the raw role code stored in App state to the human-readable
// label shown next to the user's name in the topbar. Unknown values
// fall through unchanged so the app doesn't hide unexpected roles.
const POSITION_DISPLAY_NAMES = {
  CEO: "CEO",
  PD: "Product Manager",
  PM: "Product Marketing",
  OP: "Operations Manager",
  FI: "Finance Manager",
};

const formatPosition = (position) => {
  if (!position) return position;
  const key = String(position).toUpperCase();
  return POSITION_DISPLAY_NAMES[key] || position;
};

class HeaderUserGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false
    };
  }

  logout() {
    if (Auth.isUserAuthenticated()) {
      Auth.deauthenticateUser();
    }

    changeLocation("/login");
  }

  openContactSupport = () => {
    EventEmitter.getInstance().trigger(OPEN_CONTACT_SUPPORT_EVENT);
  }

  showMenu = (event) => {
    event.preventDefault();

    this.setState(
      {
        showMenu: true
      },
      () => {
        document.addEventListener("click", this.closeMenu);
      }
    );
  }

  closeMenu = () => {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener("click", this.closeMenu);
    });
  }

  render() {
    const { name, team_color, position, isStudent } = this.props;
    return (
      <div className="header__user__group" onClick={this.showMenu}>
        {" "}
        <Avatar name={name} color={team_color} size={isStudent ? 50 : 45} round={true} />
        <p className="username">{name}</p>
        {position && (
          <p className="position">({formatPosition(position)})</p>
        )}
        <img src={dropdownArrowIcon} className="icon-dropdown" alt="Dropdown" />
        {this.state.showMenu ? (
          <div className="menu">
            <ul className="drop__down__menu">
              {isStudent && (
                <li>
                  <MyProfileLink />
                </li>
              )}
              {isStudent && (
                <li>
                  <TeamProfileLink />
                </li>
              )}
              {isStudent && (
                <li>
                  <Link
                    to="/ceo/audit-trail"
                  >
                    Audit Trail
                  </Link>
                </li>
              )}
              <li>
                <button onClick={this.openContactSupport}>Contact Support</button>
              </li>
              <li>
                <button onClick={this.logout}>Log Off</button>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
    );
  }
}

export default HeaderUserGroup;



// WEBPACK FOOTER //
// ./src/components/navigation/topbar/header-user-group.js